import * as React from 'react'
import IconDesktop1 from '../../../assets/images/header/icon-desktop1.svg'
import IconDesktop2 from '../../../assets/images/header/icon-desktop2.svg'
import IconDesktop3 from '../../../assets/images/header/icon-desktop3.svg'
import LastStageIcon from '../../../assets/images/header/icon-desktop4.svg'

export const participationSteps = (redirectionForm) => {
  return process.env.LOCALE === "es-EC" ? [
    {
      icon: IconDesktop1,
      description: <b>1. Compra productos Nosotras y guarda tus empaques</b>,
    },
    {
      icon: IconDesktop2,
      description: (
        <>
          <b>2.</b> Regístrate en <a href="/registro/">NosotrasOnline y participa</a>
        </>
      ),
    },
    {
      icon: LastStageIcon,
      description: (
        <>
          <b>3. ¡Comienza a</b>{' '}
            <a
              id='ingresoClaves'
              href={redirectionForm}
              className="underline"
              onClick={() => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interacciones - Ingresar',
                  category: 'cole challenge',
                  action: 'click',
                  label: 'ingresar',
                })
              }}
            >
              ingresar
            </a>{' '}
          <b>tus claves!</b> Ganará la persona que más claves ingrese
        </>
      ),
    },
  ]
  :
  [
    {
      icon: IconDesktop1,
      description: <b>1. Compra productos Nosotras y guarda tus empaques.</b>,
    },
    {
      icon: IconDesktop2,
      description: (
        <>
          <b>2.</b> Regístrate en <a href="/registro/">NosotrasOnline</a>
        </>
      ),
    },
    {
      icon: IconDesktop3,
      description: (
        <>
          <b>3. Podrás participar</b> individualmente y también sumar tus claves
          personales para que tu colegio gane
        </>
      ),
    },
    {
      icon: LastStageIcon,
      description: (
        <>
          <b>4. ¡Comienza a</b>{' '}
            <a
              id='ingresoClaves'
              href={redirectionForm}
              className="underline"
              onClick={() => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interacciones - Ingresar',
                  category: 'cole challenge',
                  action: 'click',
                  label: 'ingresar',
                })
              }}
            >
              ingresar
            </a>{' '}
          <b>tus claves personales!</b> Ganarán las personas y el colegio
          que más claves personales ingrese
        </>
      ),
    },
  ]
}


export const participationStages = process.env.LOCALE === "es-EC" ? [
  {
    title: 'Etapa 1:',
    description: '1 ganadora de Iphone XR y 4 ganadoras de 6 meses de productos Nosotras.',
    winnersNumber: '5 GANADORAS',
  },
  {
    title: 'Etapa 2:',
    description: '1 ganadora de Iphone 13 y 4 ganadoras de 6 meses de productos Nosotras.',
    winnersNumber: '5 GANADORAS',
  },
]
:
[
  {
    title: 'Etapa 1:',
    description: '1 Iphone 13 y 4 kits con productos Nosotras por 6 meses',
    winnersNumber: '5 GANADORAS',
  },
  {
    title: 'Etapa 2:',
    description: '1 Iphone 13 y 4 kits con productos Nosotras por 6 meses',
    winnersNumber: '5 GANADORAS',
  },
  {
    title: 'Etapa 3:',
    description: '1 Iphone 13 y 4 kits con productos Nosotras por 6 meses',
    winnersNumber: '5 GANADORAS',
  },
  {
    title: 'Etapa final:',
    description: '1 fiesta para el colegio',
    winnersNumber: '1 COLEGIO GANADOR',
  },
]
